import { ToasterService } from '../../../service/common/toaster.service';
import { Component, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, NgIf } from '@angular/common';
import { CommonService, CrudComponent } from 'wire-frame';
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';
import { SidebarModule } from 'primeng/sidebar';


import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccordionModule } from 'primeng/accordion';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AutoCompleteModule } from "primeng/autocomplete";
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TooltipModule } from 'primeng/tooltip';

import { AppointmentService } from '../../../service/admin/appointment.service';
import { CalendarComponent } from '../calendar/calendar.component';  // ✅ standalone Calendar
import { ClinicService } from '../../../service/admin/clinic.service';
import { UserService } from '../../../service/admin/user.service';
import { PatientRegistrationService } from '../../../service/admin/patient-registration.service';
import { PrescriptionsService } from '../../../service/admin/prescriptions.service';
// import { NgIf } from "../../../../../node_modules_/@angular/common/index";

import { StatusBadgePipe } from '../../../status-badge.pipe';

@Component({
  selector: 'app-appointment',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    DropdownModule,
    ToolbarModule,
    ConfirmDialogModule,
    EditorModule,
    CalendarComponent,
    TabViewModule,
    InputTextModule,
    FileUploadModule,
    InputTextareaModule,
    AccordionModule,
    ScrollPanelModule,
    ButtonModule,
    AutoCompleteModule,
    DialogModule,
    FloatLabelModule,
    NgIf,
    SidebarModule,
    ConfirmPopupModule,
    TooltipModule,
    StatusBadgePipe
  ],
  providers: [
    ConfirmationService,
    CommonService,
    AppointmentService,
    ClinicService,
    UserService,
    PatientRegistrationService
  ],
  templateUrl: './appointment.component.html',
  styleUrl: './appointment.component.scss'
})
export class AppointmentComponent implements OnInit, OnDestroy {
  readonly paymentMonthOptions = Array.from({ length: 12 }, (_, index) => index + 1);
  public checked: boolean = false;
  public AppointmentList = [];
  pationtIndex: number = 0;
  medicineIndex: number = 0;
  public editRecord = null;
  public Appointment = {
    id: 0,
    country: '',
    flag_svg: '',
    description: '',
    detail_description: '',
    price: '',
    footer: '',
    visa_type: '',
    status: true,
    service_fee: ''
  };

  public patient = {
    name: '',
    salutation: '',

  }

  public visaTypes = [
    { label: 'E-VISA', value: 'E-VISA' },
    { label: 'DAC', value: 'DAC' },
    { label: 'ETA', value: 'ETA' },
    { label: 'EVOA', value: 'EVOA' },
    { label: 'PAR', value: 'PAR' },
    { label: 'STICKER VISA', value: 'STICKER VISA' },
  ];

  public closeFormEvent: boolean = false;
  public openDeletePopup: any = null;
  public activeMenu: string = 'personal';

  // selectedDate: string = new Date().toISOString().slice(0, 10);
  selectedDate: string = new Date(Date.now() + 19800000).toISOString().slice(0, 10);
  public queue: any[] = [];
  public nextPatientAppointmentId: number | null = null;
  public medicineNextPatientIndex: number = -1;
  public medicineQueueTypeFilter: 'all' | 'normal' | 'scheduled' = 'all';
  public medicineQueueModeFilter: 'all' | 'OPD' | 'COURIER' | 'NRI' = 'all';
  public queueTypeFilter: 'all' | 'new' | 'follow_up' = 'all';
  public queueModeFilter: 'all' | 'OPD' | 'COURIER' | 'NRI' | 'MC' = 'all';
  public medicineQueue: any[] = [];
  public allMedicineQueue: any[] = [];
  public visibleMedicineQueue: any[] = [];
  public medicineQueueCounts: Record<'all' | 'normal' | 'scheduled' | 'OPD' | 'COURIER' | 'NRI', number> = {
    all: 0,
    normal: 0,
    scheduled: 0,
    OPD: 0,
    COURIER: 0,
    NRI: 0
  };
  public patientsList: any[] = [];
  selectedPatient: any = {};
  visible: boolean = false;

  public clinicList: any[] = [];
  public doctorsList: any[] = [];

  clinic_id: number | null = null;
  doctor_id: number | null = null;

  showFilters: boolean = false;

  showContextDialog: boolean = false;

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  filteredRecords: any[] = [];

  isPatientVisible: boolean = false;
  isMedicineVisible: boolean = false;
  private readonly nextQueuePriority: string[] = ['assistant_doctor_done', 'assistant_doctor', 'scheduled'];
  private hotkeySidebarEl: Element | null = null;
  private openQueueListener?: () => void;
  private openMedicineQueueListener?: () => void;

  basePersonalDue = 0;
  netBaseDue = 0;
  paymentBaseVisitFee = 0;
  paymentDurationMode: 'half' | 'monthly' = 'monthly';
  paymentMonthCount = 1;
  paymentRxLines: Array<{ id: number; title: string; duration: string; price: number }> = [];

  // action = '';
  // collect_payment = true;

  constructor(
    public common: CommonService,
    private toast: ToasterService,
    private confirmationService: ConfirmationService,
    private appointmentService: AppointmentService,
    private clinicService: ClinicService,
    private userService: UserService,
    private patientRegistrationService: PatientRegistrationService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private prescriptionsService: PrescriptionsService,
    private statusBadgePipe: StatusBadgePipe
  ) {
    this.common.breadCrum = {
      title: 'Visa Card Master',
      icon: 'user',
      list: ['Visa Card Master'],
    };
    this.common.setCrudTableHeaders([]);
    this.common.setCrudActions([]);
  }

  ngOnInit() {
    this.getAppointments();
    // this.loadQueue();
    // this.loadMedicineQueue();
    this.getClinic();
    this.getDoctors();

    this.hotkeySidebarEl = document.querySelector('[data-hotkey="patient-search"]');
    this.openQueueListener = () => this.openQueueSidebar();
    this.openMedicineQueueListener = () => this.openMedicineQueueSidebar();
    this.hotkeySidebarEl?.addEventListener('open-queue', this.openQueueListener);
    this.hotkeySidebarEl?.addEventListener('open-medicine-queue', this.openMedicineQueueListener);

    const badge = this.statusBadgePipe.transform('doctor');

    // setInterval(() => {
    //   if(this.common.getLoggedInUser())
    //   {
    //     this.loadQueue();
    //     this.loadMedicineQueue();
    //   }
    // }, 10000);

    const storedClinic = sessionStorage.getItem('clinic_id');
    const storedDoctor = sessionStorage.getItem('doctor_id');

    if (storedClinic) this.clinic_id = +storedClinic;
    if (storedDoctor) this.doctor_id = +storedDoctor;
  }

  ngOnDestroy(): void {
    if (this.hotkeySidebarEl && this.openQueueListener) {
      this.hotkeySidebarEl.removeEventListener('open-queue', this.openQueueListener);
    }
    if (this.hotkeySidebarEl && this.openMedicineQueueListener) {
      this.hotkeySidebarEl.removeEventListener('open-medicine-queue', this.openMedicineQueueListener);
    }
    this.openQueueListener = undefined;
    this.openMedicineQueueListener = undefined;
    this.hotkeySidebarEl = null;
  }

  getClinic() {
    this.clinicService.getClinic().subscribe({
      next: (res: any) => {
        this.clinicList = Array.isArray(res.data)
          ? res.data.map((clinic: any) => ({
            label: clinic.name,
            value: clinic.id
          }))
          : [];
      },
      error: (err) => {
        console.error('Clinic API error:', err);
        this.clinicList = [];
      }
    });
  }

  getDoctors() {
    this.userService.getDoctors().subscribe({
      next: (res: any) => {
        this.doctorsList = Array.isArray(res.data)
          ? res.data.map((doctor: any) => ({
            label: doctor.name,
            value: doctor.id
          }))
          : [];
      },
      error: (err) => {
        console.error('Doctor API error:', err);
        this.doctorsList = [];
      }
    });
  }

  applyContext() {
    if (this.clinic_id && this.doctor_id) {
      sessionStorage.setItem('clinic_id', this.clinic_id.toString());
      sessionStorage.setItem('doctor_id', this.doctor_id.toString());

      // console.log('Selected Clinic:', this.clinic_id);
      // console.log('Selected Doctor:', this.doctor_id);
    } else {
      alert('Please select both Clinic and Doctor');
    }
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    }
  }

  normalizePatientMode(mode: any): 'OPD' | 'COURIER' | 'NRI' {
    if (mode === 'NRI') {
      return 'NRI';
    }

    if (
      mode === true ||
      mode === 'true' ||
      mode === 1 ||
      mode === '1' ||
      mode === 'Courier' ||
      mode === 'COURIER'
    ) {
      return 'COURIER';
    }

    return 'OPD';
  }

  getModeInitial(mode: any): 'O' | 'C' | 'N' {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'C';
    if (normalized === 'NRI') return 'N';
    return 'O';
  }

  isMedicineCollectionItem(item: any): boolean {
    return item?.collect_later === true || item?.collect_later === 1 || item?.collect_later === '1';
  }

  getModeTitle(mode: any): string {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'Courier';
    if (normalized === 'NRI') return 'NRI';
    return 'OPD';
  }

  getModeBadgeClass(mode: any): string {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'mode-courier';
    if (normalized === 'NRI') return 'mode-nri';
    return 'mode-opd';
  }

  getMedicineQueuePaymentStatus(item: any): 'paid' | 'pending' {
    const dues = Number(item?.personal_dues ?? 0);
    if (Number.isFinite(dues) && dues <= 0) {
      return 'paid';
    }
    return 'pending';
  }

  getMedicineQueuePaymentLabel(item: any): string {
    return this.getMedicineQueuePaymentStatus(item) === 'paid'
      ? 'Awaiting meds collection'
      : 'Payment remaining';
  }

  getMedicineQueuePaymentClass(item: any): string {
    return this.getMedicineQueuePaymentStatus(item) === 'paid'
      ? 'payment-done'
      : 'payment-pending';
  }

  setMedicineQueueTypeFilter(type: 'all' | 'normal' | 'scheduled') {
    this.medicineQueueTypeFilter = type;
    this.recomputeMedicineQueueView();
  }

  setMedicineQueueModeFilter(mode: 'all' | 'OPD' | 'COURIER' | 'NRI') {
    this.medicineQueueModeFilter = mode;
    this.recomputeMedicineQueueView();
  }

  private isScheduledLaterMedicineItem(item: any): boolean {
    if (item?.collect_later === true || item?.collect_later === 1 || item?.collect_later === '1') {
      return true;
    }

    const raw = item?.collection_date;
    if (raw === null || raw === undefined) return false;

    const value = String(raw).trim().toLowerCase();
    return value !== '' && value !== 'null' && value !== 'undefined';
  }

  isMedicineQueueItemVisible(item: any): boolean {
    const isScheduled = this.isScheduledLaterMedicineItem(item);
    const normalizedMode = this.normalizePatientMode(item?.is_courier);
    const modeMatches = this.medicineQueueModeFilter === 'all'
      ? true
      : normalizedMode === this.medicineQueueModeFilter;

    if (!modeMatches) return false;
    if (this.medicineQueueTypeFilter === 'normal') return !isScheduled;
    if (this.medicineQueueTypeFilter === 'scheduled') return isScheduled;
    return true;
  }

  get normalMedicineQueueCount(): number {
    return this.medicineQueueCounts.normal;
  }

  get scheduledMedicineQueueCount(): number {
    return this.medicineQueueCounts.scheduled;
  }

  get opdMedicineQueueCount(): number {
    return this.medicineQueueCounts.OPD;
  }

  get courierMedicineQueueCount(): number {
    return this.medicineQueueCounts.COURIER;
  }

  get nriMedicineQueueCount(): number {
    return this.medicineQueueCounts.NRI;
  }

  private sanitizeNamePart(value: any): string {
    if (value === null || value === undefined) return '';

    const part = String(value).trim();
    if (!part || part.toLowerCase() === 'null' || part.toLowerCase() === 'undefined') {
      return '';
    }

    return part;
  }

  private buildPatientDisplayName(patient: any): string {
    const name = [
      this.sanitizeNamePart(patient?.first_name),
      this.sanitizeNamePart(patient?.middle_name),
      this.sanitizeNamePart(patient?.last_name)
    ].filter(Boolean).join(' ');

    if (name) return name;

    return this.sanitizeNamePart(patient?.full_name) || this.sanitizeNamePart(patient?.name);
  }

  getAppointments() {
    this.appointmentService.getAppointment().subscribe((res: any) => {
      this.AppointmentList = res.data;
      // this.AppointmentList.forEach((Appointment: any) => {
      //   Appointment['typeValue'] = Appointment['label']['value'];
      // });
    });
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => {
      this.closeFormEvent = false;
    }, 1);
  }

  clearForm() {
    this.Appointment = {
      id: 0,
      country: '',
      flag_svg: '',
      description: '',
      detail_description: '',
      price: '',
      footer: '',
      visa_type: '',
      status: true,
      service_fee: '',
    };
  }

  processAppointments() {
    if (this.Appointment?.id) {
      this.updateAppointment();
    } else {
      this.addAppointment();
    }
  }

  addAppointment() {
    this.appointmentService.addAppointment(this.Appointment).subscribe(() => {
      this.toast.add({ severity: 'success', summary: 'Success', detail: 'Visa Card added successfully' });
      this.getAppointments();
      this.closeForm();
    });
  }

  updateAppointment() {
    this.appointmentService.updateAppointment(this.Appointment).subscribe(() => {
      this.toast.add({ severity: 'success', summary: 'Success', detail: 'Visa Card updated successfully' });
      this.getAppointments();
      this.closeForm();
    });
  }

  updatePrescription() {
    this.prescriptionsService.updatePrescriptions(this.Appointment).subscribe(() => {
      this.toast.add({ severity: 'success', summary: 'Success', detail: 'Prescription updated successfully' });
      this.getAppointments();
      this.closeForm();
    });
  }

  deleteAppointment(item: any) {
    this.appointmentService.deleteAppointment(item).subscribe(() => {
      this.toast.add({ severity: 'success', summary: 'Success', detail: 'Visa Card deleted successfully' });
      this.getAppointments();
      this.closeForm();
    })
  }

  deleteRecord(event: any) {
    if (event) {
      this.deleteAppointment(event);
    }
  }

  handleEvent(event: any) {
    if (event.action.tooltip == "Update Visa Card") {
      this.editRecord = event.data;
      this.Appointment = event.data;
      setTimeout(() => { this.editRecord = null; }, 1);
    } else if (event.action.tooltip == "Delete Visa Card") {
      this.editRecord = event.data;
      this.delRecPopupOpen({ title: this.editRecord?.['country'], obj: this.editRecord });
    }
  }

  delRecPopupOpen(item: any) {
    this.openDeletePopup = item;
    setTimeout(() => {
      this.openDeletePopup = null;
    }, 1);
  }

  getColorClass(status: string): string {
    switch (status) {
      case 'scheduled':
        return 'bg-light-blue';
      case 'assistant_doctor':
        return 'bg-light-purple';
      case 'assistant_doctor_done':
        return 'bg-light-purple';
      case 'doctor':
        return 'bg-light-coral';
      case 'medicine':
        return 'bg-light-teal';
      case 'completed':
        return 'bg-light-green';
      case 'cancelled':
        return 'bg-light-red';
      case 'reception':
        return 'bg-light-slate';
      default:
        return 'bg-light-gray'; // fallback for unknown statuses
    }
  }

  private updateNextPatientIndex(): void {
    this.nextPatientAppointmentId = null;

    if (!Array.isArray(this.queue) || this.queue.length === 0) {
      return;
    }

    const visibleQueue = this.filteredQueue;
    if (!Array.isArray(visibleQueue) || visibleQueue.length === 0) {
      return;
    }

    for (const status of this.nextQueuePriority) {
      const candidate = visibleQueue.find((item: any) => item?.status === status);
      if (candidate) {
        this.nextPatientAppointmentId = Number(candidate?.appointment_id || 0) || null;
        return;
      }
    }

    this.nextPatientAppointmentId = Number(visibleQueue[0]?.appointment_id || 0) || null;
  }

  isNextPatient(item: any): boolean {
    return Number(item?.appointment_id || 0) > 0
      && Number(item?.appointment_id || 0) === this.nextPatientAppointmentId;
  }

  loadQueue() {
    this.nextPatientAppointmentId = null;
    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    // ✅ Check if clinic or doctor not selected
    if (!clinicId || !doctorId) {
      this.toast.add({
        severity: 'warn',
        summary: 'Missing Selection',
        detail: 'Select the clinic and doctor',
      });
    }

    // const date = this.selectedDate || new Date().toISOString().slice(0, 10);
    const date = this.selectedDate || new Date(Date.now() + 19800000).toISOString().slice(0, 10);

    this.appointmentService.getQueue({
      clinic_id: clinicId,
      doctor_id: doctorId,
      date: date,
      // date: "2025-09-12",
      slot: 60
    }).subscribe((res: any) => {
      if (res.success) {
        const appointments = res.data.slots.flatMap((slot: any) =>
          slot.appointments.map((appt: any) => ({
            appointment_id: appt.id,
            patient_id: appt.patient_id,
            clinic_id: appt.clinic_id,
            doctor_id: appt.doctor_id,
            time: appt.start_time,
            created_at: appt.created_at,
            raw_time: appt.created_at || appt.start_time,
            status: appt.status,
            collect_later: Boolean(appt.collect_later ?? false),
            is_courier: this.normalizePatientMode(appt.is_courier),
            appointment_type: this.normalizeAppointmentType(appt.appointment_type)
          }))
        );

        // Collect all patient IDs
        const patientIds = appointments.map((a: any) => a.patient_id);

        // Fetch all patient data in one request
        this.patientRegistrationService.getPatientsBatch(patientIds)
          .subscribe((patientRes: any) => {
            if (patientRes.success) {
              const patientsMap = new Map();
              patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

              // Map appointments to patients
              this.queue = appointments.map((appt: any) => {
                const patient = patientsMap.get(appt.patient_id);
                const displayName = this.buildPatientDisplayName(patient);
                return {
                  name: displayName,
                  full_name: displayName,
                  time: this.formatTime(appt.time),
                  raw_time: appt.raw_time,
                  status: appt.status,
                  collect_later: Boolean(appt.collect_later ?? false),
                  primary_contact: patient.primary_contact,
                  secondary_contact: patient.secondary_contact,
                  is_free: patient.is_free,
                  age: patient.age,
                  appointment_id: appt.appointment_id,
                  clinic_id: appt.clinic_id,
                  doctor_id: appt.doctor_id,
                  is_courier: this.normalizePatientMode(patient?.is_courier ?? appt.is_courier),
                  appointment_type: appt.appointment_type
                };
              });

              // Sort by time once
              this.queue.sort((a, b) => a.time.localeCompare(b.time));
              this.updateNextPatientIndex();
              // console.log('Loaded consultation queue:', this.queue);
            }
          });
      }
    });
  }

  loadMedicineQueue() {
    // Keep backward compatibility for any stale calls.
    this.loadAllMedicineQueue();
  }

  searchPatients(event: any) {
    const query = event.query;
    this.http.get<any>('https://clinic.mdssuicideprevention.in/api/patient/search', { params: { q: query }, ...this.getAuthHeaders() })
      .subscribe(res => {
        if (!res.data || res.data.length === 0) {
          this.patientsList = [];
          this.toast.add({
            severity: 'info',
            summary: 'Info',
            detail: `No patients found for "${query}".`
          });
        } else {
          this.patientsList = res.data.map((p: any) => ({
            ...p,
            full_name: `${p.full_name} (${p.patient_number})`
          }));
        }
        // Stop spinner and update view
        this.cdr.detectChanges();
      }, error => {
        this.patientsList = [];
        this.toast.add({
          severity: 'info',
          summary: 'Info',
          detail: 'No patients found.'
        });
        this.cdr.detectChanges();
      });
  }

  showMedicineDialog(item: any) {
    // if (item.status === 'medicine') {
    //   this.toast.add({
    //     severity: 'info',
    //     summary: 'Info',
    //     detail: 'The Patient is in Queue to collect Medicines.'
    //   });
    //   return;
    // }; // block click
    this.visible = true;
    this.selectedPatient = item;

    // 🔒 snapshot base due ONCE
    // this.basePersonalDue = this.toNumber(item.personal_dues);

    const existingDue = this.toNumber(item.personal_dues);
    const existingFees = this.toNumber(item.visit_fees);
    const existingCash = this.toNumber(item.received_cash);
    const existingOnline = this.toNumber(item.received_online);

    const existingPaid = existingCash + existingOnline;

    // 🔒 THIS is the fix
    this.netBaseDue = existingDue - existingFees + existingPaid;
    this.hydratePaymentRxLines(item, existingFees);
    this.initializePaymentPlan(this.toNumber(this.selectedPatient.visit_fees) || existingFees);

    // optional safety
    this.selectedPatient.visit_fees ??= 0;
    this.selectedPatient.received_cash ??= 0;
    this.selectedPatient.received_online ??= 0;
    this.updatePersonalDues();
    // console.log('Selected Patient:', this.selectedPatient);
  }

  changeStatus(item: any, mode: 'payment' | 'completed') {

    // console.log(item);
    // return;

    let status = '';

    if (item.status === 'medicine' && mode === 'payment') {
      status = 'medicine';
    }

    if (item.status === 'reception' && mode === 'payment') {
      status = 'reception';
    }

    if (mode === 'completed') {
      status = 'completed';
    }

    // this.appointmentService.changeStatus(item.appointment_id, {status: status}).pipe(
    //   switchMap((res: any) => {
    //     if (res.success) {
    //       const payload = {
    //         id: item.id,
    //         appointment_id: item.appointment_id,
    //         received_cash: item.received_cash || 0,
    //         received_online: item.received_online || 0,
    //         personal_dues: item.personal_dues,
    //         visit_fees: item.visit_fees,
    //         action: "save_payment",
    //         collect_payment: true,
    //       };
    //       return this.prescriptionsService.updatePrescriptions(payload);
    //     }
    //     return EMPTY; // stops the chain if not successful
    //   })
    // ).subscribe({
    //   next: () => {
    //     this.visible = false;
    //     // this.loadMedicineQueue(); // Refresh only after prescriptions update
    //     this.loadAllMedicineQueue(); // Refresh only after prescriptions update
    //     this.toast.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Status updated successfully.'
    //     });
    //   },
    //   error: (err) => {
    //     console.error('Error changing status or updating prescriptions:', err);
    //     this.toast.add({
    //       severity: 'error',
    //       summary: 'Error',
    //       detail: 'Something went wrong. Please try again.'
    //     });
    //   }
    // });

    this.appointmentService
      .changeStatus(item.appointment_id, { status })
      .pipe(
        switchMap((res: any) => {
          if (!res.success) {
            return EMPTY;
          }

          /**
           * Decide intent EXPLICITLY
           */
          let main_action: 'save_payment' | 'complete';
          let collect_payment = false;

          if (mode === 'payment') {
            main_action = 'save_payment';
            collect_payment = true;
          } else {
            main_action = 'complete';

            // collect payment ONLY if money is entered
            collect_payment =
              (item.received_cash ?? 0) > 0 ||
              (item.received_online ?? 0) > 0;
          }

          const payload = {
            id: item.id,
            appointment_id: item.appointment_id,
            received_cash: item.received_cash || 0,
            received_online: item.received_online || 0,
            personal_dues: item.personal_dues,
            visit_fees: Math.round(this.toNumber(item.visit_fees)),
            rx_prices: this.paymentRxLines.map((line) => ({
              id: line.id,
              price: Math.max(0, Math.round(this.toNumber(line.price))),
            })),
            main_action,
            collect_payment,
          };

          return this.prescriptionsService.updatePrescriptions(payload);
        })
      )
      .subscribe({
        next: () => {
          this.visible = false;
          this.loadAllMedicineQueue();
          this.toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Status updated successfully.',
          });
        },
        error: (err) => {
          console.error('Error changing status or updating prescriptions:', err);
          this.toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Something went wrong. Please try again.',
          });
        },
      });
  }

  confirmCompleteAppointment(event: Event, item?: any) {
    this.confirmationService.confirm({
      key: 'templatePopup', // 👈 same popup, different content
      target: event?.target as EventTarget,
      message: `Are you sure you want to Complete the appointment`,
      icon: 'pi pi-check',
      acceptLabel: 'Confirm',
      // rejectLabel: 'Cancel',
      acceptButtonStyleClass: 'custom-accept-btn',
      rejectButtonStyleClass: 'custom-reject-btn',
      accept: () => this.changeStatus(item, 'completed'),
    });
  }

  // calculatePersonalDues(records: any[], current: any): number {
  //   let lastDue = 0;

  //   if (records && records.length > 0) {
  //     // Find the most recent prescription with dues > 0
  //     const last = records.find((r: any) => r.personal_dues && r.personal_dues >= 0);
  //     if (last) {
  //       lastDue = Number(last.personal_dues);
  //     }
  //   }

  //   const visitFees = Number(current.visit_fees) || 0;
  //   const receivedCash = Number(current.received_cash) || 0;
  //   const receivedOnline = Number(current.received_online) || 0;

  //   // return (lastDue - (receivedCash + receivedOnline));
  //   return (visitFees - (receivedCash + receivedOnline)) + lastDue;
  // }

  // calculatePersonalDues(records: any[], current: any): number {
  //   let lastDue = 0;

  //   // history sorted newest → oldest
  //   if (records && records.length > 0) {
  //     lastDue = Number(records[0].personal_dues) || 0;
  //   }

  //   const visitFees = Number(current.visit_fees) || 0;
  //   const receivedCash = Number(current.received_cash) || 0;
  //   const receivedOnline = Number(current.received_online) || 0;

  //   return (visitFees - (receivedCash + receivedOnline)) + lastDue;
  // }

  // calculatePersonalDues(records: any[], current: any): number {
  //   let outstanding = 0;

  //   // history[0] = the last saved dues
  //   if (records && records.length > 0) {
  //     outstanding = Number(records[0].personal_dues) || 0;
  //   }

  //   const visitFees = Number(current.visit_fees) || 0;
  //   const receivedCash = Number(current.received_cash) || 0;
  //   const receivedOnline = Number(current.received_online) || 0;

  //   const paid = receivedCash + receivedOnline;

  //   return outstanding + (visitFees - paid);
  // }

  calculatePersonalDues(records: any[]): number {
    if (!records || records.length === 0) return 0;

    const latest = records[0];

    const storedDue = Number(latest.personal_dues);
    const visitFees = Number(latest.visit_fees);
    const receivedCash = Number(latest.received_cash);
    const receivedOnline = Number(latest.received_online);

    // If backend already stored the due correctly → return it
    if (!isNaN(storedDue) && storedDue !== null) {
      return storedDue;
    }

    // Otherwise calculate fresh
    const paid = receivedCash + receivedOnline;
    return visitFees - paid;
  }

  calculateSavedDues(records: any[]): number {
    if (!records || records.length === 0) return 0;

    const latest = records[0];

    const stored = Number(latest.personal_dues);
    if (!isNaN(stored)) {
      return stored; // already calculated by backend
    }

    const fees = Number(latest.visit_fees || 0);
    const paid = Number(latest.received_cash || 0) + Number(latest.received_online || 0);

    return fees - paid;
  }

  calculateLiveDue(patient: any): number {
    const previousDue = Number(patient.history?.[1]?.personal_dues || 0);
    const visitFees = Number(patient.visit_fees || 0);
    const paid = Number(patient.received_cash || 0) + Number(patient.received_online || 0);

    return previousDue + (visitFees - paid);
  }

  // updateDues() {
  //   this.selectedPatient.personal_dues = this.calculateFinalPersonalDues(
  //     this.selectedPatient.history,
  //     this.selectedPatient
  //   );
  // }

  // calculateFinalPersonalDues(records: any[], current: any): number {
  //   if (!current) return 0;

  //   // find last saved dues
  //   let previousDue = 0;

  //   if (Array.isArray(records) && records.length > 0) {
  //     const lastRecord = [...records].reverse()
  //       .find(r => r.personal_dues != null && r.personal_dues !== '' && !isNaN(r.personal_dues));

  //     if (lastRecord) previousDue = Number(lastRecord.personal_dues);
  //   }

  //   const visitFees      = Number(current.visit_fees) || 0;
  //   const receivedCash   = Number(current.received_cash) || 0;
  //   const receivedOnline = Number(current.received_online) || 0;

  //   const totalPaid  = receivedCash + receivedOnline;
  //   const finalDue   = (previousDue + visitFees) - totalPaid;

  //   return finalDue > 0 ? finalDue : 0;  // no negative circus dues
  // }

  // 

  // recalculateDues(): void {
  //   if (!this.selectedPatient) return;

  //   this.selectedPatient.personal_dues =
  //     this.calculateFinalPersonalDues(
  //       this.selectedPatient.history ?? [],
  //       this.selectedPatient
  //     );
  // }

  // calculateFinalPersonalDues(records: any[], current: any): number {
  //   const previousDue = this.getLastValidDue(records);

  //   const visitFees      = this.toNumber(current.visit_fees);
  //   const receivedCash   = this.toNumber(current.received_cash);
  //   const receivedOnline = this.toNumber(current.received_online);

  //   const totalPaid = receivedCash + receivedOnline;
  //   const finalDue  = previousDue + visitFees - totalPaid;

  //   return Math.max(finalDue, 0);
  // }

  // private getLastValidDue(records: any[]): number {
  //   if (!Array.isArray(records)) return 0;

  //   for (let i = records.length - 1; i >= 0; i--) {
  //     const due = Number(records[i]?.personal_dues);
  //     if (!isNaN(due)) {
  //       return due;
  //     }
  //   }

  //   return 0;
  // }

  // private toNumber(value: any): number {
  //   const num = Number(value);
  //   return isNaN(num) ? 0 : num;
  // }

  //   recalculateDues(): void {
  //   if (!this.selectedPatient) return;

  //   const history = this.selectedPatient.history ?? [];

  //   this.selectedPatient.personal_dues =
  //     this.calculateFinalPersonalDues(
  //       history,
  //       this.selectedPatient
  //     );
  // }

  // calculateFinalPersonalDues(records: any[], current: any): number {
  //   const previousDue = this.getLastSavedDue(records, current?.id);

  //   const visitFees      = this.toNumber(current.visit_fees);
  //   const receivedCash   = this.toNumber(current.received_cash);
  //   const receivedOnline = this.toNumber(current.received_online);

  //   const totalPaid = receivedCash + receivedOnline;

  //   const finalDue = previousDue + visitFees - totalPaid;

  //   return Math.max(finalDue, 0);
  // }

  // /**
  //  * Gets dues from last COMPLETED visit only
  //  * Excludes current visit if already present in history
  //  */
  // private getLastSavedDue(records: any[], currentId: any): number {
  //   if (!Array.isArray(records)) return 0;

  //   for (let i = records.length - 1; i >= 0; i--) {
  //     const r = records[i];

  //     // 🔥 CRITICAL: skip current visit
  //     if (r?.id === currentId) continue;

  //     const due = Number(r?.personal_dues);
  //     if (!isNaN(due)) {
  //       return due;
  //     }
  //   }

  //   return 0;
  // }

  // updatePersonalDues(): void {
  //   if (!this.selectedPatient) return;

  //   const fees   = this.toNumber(this.selectedPatient.visit_fees);
  //   const cash   = this.toNumber(this.selectedPatient.received_cash);
  //   const online = this.toNumber(this.selectedPatient.received_online);

  //   const totalPaid = cash + online;
  //   const due = fees - totalPaid;

  //   this.selectedPatient.personal_dues = Math.max(due, 0);
  // }

  // updatePersonalDues(): void {
  //   if (!this.selectedPatient) return;

  //   const fees   = this.toNumber(this.selectedPatient.visit_fees);
  //   const cash   = this.toNumber(this.selectedPatient.received_cash);
  //   const online = this.toNumber(this.selectedPatient.received_online);

  //   const totalPaid = cash + online;

  //   const due =
  //     this.basePersonalDue +
  //     fees -
  //     totalPaid;

  //   this.selectedPatient.personal_dues = Math.max(due, 0);
  // }

  updatePersonalDues(): void {
    if (!this.selectedPatient) return;

    const fees = this.toNumber(this.selectedPatient.visit_fees);
    const cash = this.toNumber(this.selectedPatient.received_cash);
    const online = this.toNumber(this.selectedPatient.received_online);

    const totalPaid = cash + online;

    const due =
      this.netBaseDue +
      fees -
      totalPaid;

    this.selectedPatient.personal_dues = Math.max(due, 0);
  }

  get paymentReceivedTotal(): number {
    return this.toNumber(this.selectedPatient?.received_cash) + this.toNumber(this.selectedPatient?.received_online);
  }

  get priorCarryForward(): number {
    return Math.round(this.toNumber(this.netBaseDue) * 100) / 100;
  }

  get paymentPlanLabel(): string {
    if (this.paymentDurationMode === 'half') {
      return '15-day plan';
    }
    if (this.paymentMonthCount <= 1) {
      return '1-month plan';
    }
    return `${this.paymentMonthCount}-month plan`;
  }

  patientInitials(name: string | null | undefined): string {
    const parts = String(name || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  fillFullPayment(mode: 'cash' | 'online' | 'split'): void {
    if (!this.selectedPatient) return;

    const fees = this.toNumber(this.selectedPatient.visit_fees);
    const target = Math.max(0, fees + this.toNumber(this.netBaseDue));

    if (mode === 'cash') {
      this.selectedPatient.received_cash = target;
      this.selectedPatient.received_online = 0;
    } else if (mode === 'online') {
      this.selectedPatient.received_cash = 0;
      this.selectedPatient.received_online = target;
    } else {
      const half = Math.floor(target / 2);
      this.selectedPatient.received_cash = half;
      this.selectedPatient.received_online = target - half;
    }

    this.updatePersonalDues();
  }

  clearCollectedPayment(): void {
    if (!this.selectedPatient) return;
    this.selectedPatient.received_cash = 0;
    this.selectedPatient.received_online = 0;
    this.updatePersonalDues();
  }

  bumpPaymentMonths(delta: number, event?: Event): void {
    event?.stopPropagation();
    this.setPaymentMonthCount(this.paymentMonthCount + delta);
  }

  initializePaymentPlan(visitFees: any): void {
    const normalizedFee = Math.max(this.toNumber(visitFees), 0);
    this.paymentBaseVisitFee = normalizedFee;
    this.paymentDurationMode = 'monthly';
    this.paymentMonthCount = 1;
  }

  setPaymentDurationMode(mode: 'half' | 'monthly'): void {
    this.paymentDurationMode = mode;
    if (mode === 'half') {
      this.paymentMonthCount = 1;
    }
    this.applyPaymentPlan();
  }

  setPaymentMonthCount(months: any): void {
    const parsed = Math.min(12, Math.max(1, this.toNumber(months) || 1));
    this.paymentMonthCount = parsed;
    this.paymentDurationMode = 'monthly';
    this.applyPaymentPlan();
  }

  applyPaymentPlan(): void {
    if (!this.selectedPatient) return;

    const baseFee = Math.max(this.toNumber(this.paymentBaseVisitFee), 0);
    const calculatedFee = this.paymentDurationMode === 'half'
      ? baseFee / 2
      : baseFee * this.paymentMonthCount;

    this.selectedPatient.visit_fees = Math.round(calculatedFee * 100) / 100;
    this.distributeVisitFeesAcrossRxLines(this.selectedPatient.visit_fees);
    if (this.paymentRxLines.length) {
      this.selectedPatient.visit_fees = this.paymentRxTotal;
    }
    this.updatePersonalDues();
  }

  syncPaymentBaseFee(): void {
    const currentFee = Math.max(this.toNumber(this.selectedPatient?.visit_fees), 0);

    if (this.paymentDurationMode === 'half') {
      this.paymentBaseVisitFee = currentFee * 2;
    } else {
      this.paymentBaseVisitFee = this.paymentMonthCount > 0
        ? currentFee / this.paymentMonthCount
        : currentFee;
    }

    this.paymentBaseVisitFee = Math.round(this.paymentBaseVisitFee * 100) / 100;
    this.distributeVisitFeesAcrossRxLines(currentFee);
    this.updatePersonalDues();
  }

  get paymentRxTotal(): number {
    return this.paymentRxLines.reduce((sum, line) => sum + this.toNumber(line.price), 0);
  }

  paymentRxTitle(line: { title?: string }, index: number): string {
    const title = String(line?.title || '').trim();
    return title || `Rx ${index + 1}`;
  }

  onPaymentRxPriceChange(): void {
    if (!this.selectedPatient) return;
    this.selectedPatient.visit_fees = Math.round(this.paymentRxTotal);
    this.syncPaymentPlanFromVisitFees();
    this.updatePersonalDues();
  }

  private hydratePaymentRxLines(item: any, visitFees: number): void {
    const source = Array.isArray(item?.rx_lines)
      ? item.rx_lines
      : (Array.isArray(item?.prescriptions) ? item.prescriptions : []);

    this.paymentRxLines = source.map((block: any, index: number) => ({
      id: Number(block?.id) || index + 1,
      title: String(block?.title || '').trim(),
      duration: String(block?.duration || '').trim(),
      price: Math.max(0, Math.round(this.toNumber(block?.price))),
    }));

    const pricedSum = this.paymentRxTotal;
    if (this.paymentRxLines.length && pricedSum > 0) {
      this.selectedPatient.visit_fees = pricedSum;
    } else if (this.paymentRxLines.length && visitFees > 0) {
      this.distributeVisitFeesAcrossRxLines(visitFees);
    }
  }

  private distributeVisitFeesAcrossRxLines(total: number): void {
    const count = this.paymentRxLines.length;
    if (!count) return;

    const amount = Math.max(0, Math.round(this.toNumber(total)));
    const weights = this.paymentRxLines.map((line) => Math.max(0, this.toNumber(line.price)));
    const weightSum = weights.reduce((sum, weight) => sum + weight, 0);

    if (weightSum > 0) {
      let allocated = 0;
      this.paymentRxLines.forEach((line, index) => {
        if (index === count - 1) {
          line.price = amount - allocated;
          return;
        }
        const share = Math.round((weights[index] / weightSum) * amount);
        line.price = share;
        allocated += share;
      });
      return;
    }

    const base = Math.floor(amount / count);
    let remainder = amount - base * count;
    this.paymentRxLines.forEach((line) => {
      line.price = base + (remainder > 0 ? 1 : 0);
      if (remainder > 0) remainder -= 1;
    });
  }

  private syncPaymentPlanFromVisitFees(): void {
    const currentFee = Math.max(this.toNumber(this.selectedPatient?.visit_fees), 0);
    if (this.paymentDurationMode === 'half') {
      this.paymentBaseVisitFee = currentFee * 2;
    } else {
      this.paymentBaseVisitFee = this.paymentMonthCount > 0
        ? currentFee / this.paymentMonthCount
        : currentFee;
    }
    this.paymentBaseVisitFee = Math.round(this.paymentBaseVisitFee * 100) / 100;
  }

  private toNumber(value: any): number {
    const n = Number(value);
    return isNaN(n) ? 0 : n;
  }

  formatTime(time: any): string {
    if (!time && time !== 0) return '';

    try {
      // If already HH:MM or HH:MM:SS
      if (typeof time === 'string' && /^\d{1,2}:\d{2}(:\d{2})?$/.test(time)) {
        return time.slice(0, 5).padStart(4, '0');
      }

      // If numeric timestamp
      if (typeof time === 'number') {
        const d = new Date(time);
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
      }

      // Try parsing ISO or full datetime string
      const parsed = new Date(time);
      if (!isNaN(parsed.getTime())) {
        const hh = String(parsed.getHours()).padStart(2, '0');
        const mm = String(parsed.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
      }

      // Fallback to original
      return String(time).slice(0, 5);
    } catch {
      return String(time);
    }
  }

  private normalizeAppointmentType(type: any): 'new' | 'follow_up' | 'other' {
    const normalized = String(type || '').trim().toLowerCase().replace(/\s+/g, '_');
    if (normalized === 'new') return 'new';
    if (normalized === 'follow_up') return 'follow_up';
    return 'other';
  }


  setQueueTypeFilter(type: 'all' | 'new' | 'follow_up') {
    this.queueTypeFilter = type;
    this.updateNextPatientIndex();
  }

  setQueueModeFilter(mode: 'all' | 'OPD' | 'COURIER' | 'NRI' | 'MC') {
    this.queueModeFilter = mode;
    this.updateNextPatientIndex();
  }

  get queueNewCount(): number {
    return this.queue.filter((item: any) => this.normalizeAppointmentType(item?.appointment_type) === 'new').length;
  }

  get queueFollowUpCount(): number {
    return this.queue.filter((item: any) => this.normalizeAppointmentType(item?.appointment_type) === 'follow_up').length;
  }

  get queueOpdCount(): number {
    return this.queue.filter((item: any) => this.normalizePatientMode(item?.is_courier) === 'OPD').length;
  }

  get queueCourierCount(): number {
    return this.queue.filter((item: any) => this.normalizePatientMode(item?.is_courier) === 'COURIER').length;
  }

  get queueNriCount(): number {
    return this.queue.filter((item: any) => this.normalizePatientMode(item?.is_courier) === 'NRI').length;
  }

  get queueMedicineCollectionCount(): number {
    return this.queue.filter((item: any) => this.isMedicineCollectionItem(item)).length;
  }

  get filteredQueue(): any[] {
    const typeFiltered = this.queue.filter((item: any) => {
      if (this.queueTypeFilter === 'new') {
        return this.normalizeAppointmentType(item?.appointment_type) === 'new';
      }

      if (this.queueTypeFilter === 'follow_up') {
        return this.normalizeAppointmentType(item?.appointment_type) === 'follow_up';
      }

      return true;
    });

    if (this.queueModeFilter === 'all') {
      return typeFiltered;
    }

    if (this.queueModeFilter === 'MC') {
      return typeFiltered.filter((item: any) => this.isMedicineCollectionItem(item));
    }

    return typeFiltered.filter(
      (item: any) => this.normalizePatientMode(item?.is_courier) === this.queueModeFilter
    );
  }

  getAppointmentTypeLabel(type: any): string {
    const normalized = this.normalizeAppointmentType(type);
    if (normalized === 'new') return 'New';
    if (normalized === 'follow_up') return 'Follow Up';
    return '';
  }

  getAppointmentTypeClass(type: any): string {
    const normalized = this.normalizeAppointmentType(type);
    if (normalized === 'new') return 'apt-new';
    if (normalized === 'follow_up') return 'apt-followup';
    return 'apt-other';
  }

  /**
   * ✅ Format date to “8th Nov 25”
   */
  private formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    const suffix = this.getOrdinalSuffix(day);
    return `${day}${suffix} ${month} ${year}`;
  }

  /**
   * Helper to add correct suffix (st, nd, rd, th)
   */
  private getOrdinalSuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  openQueueSidebar() {
    this.loadQueue();
    this.isPatientVisible = true;
  }

  openMedicineQueueSidebar() {
    this.loadAllMedicineQueue();
    // this.loadMedicineQueue();
    this.isMedicineVisible = true;
  }


  loadAllMedicineQueue() {
    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    if (!clinicId || !doctorId) {
      this.toast.add({
        severity: 'warn',
        summary: 'Missing Selection',
        detail: 'Select clinic and doctor',
      });
      return;
    }

    this.appointmentService.getAllMedicineQueue({ clinic_id: clinicId, doctor_id: doctorId })
      .subscribe((res: any) => {
        // Support two common response shapes: { success:true, data: { appointments: [...] } }
        // and { success:true, data: [...] }
        const dataArr: any[] = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.appointments)
            ? res.data.appointments
            : [];

        if (!res.success || dataArr.length === 0) {
          this.allMedicineQueue = [];
          this.recomputeMedicineQueueView();
          return;
        }

        // Normalize various field names from backend (id vs appointment_id, start_time vs appointment_time)
        this.allMedicineQueue = dataArr.map((a: any) => {
          const apptId = a.appointment_id ?? a.id ?? a.appointmentId ?? a.appointment?.id;
          const apptDate = a.appointment_date ?? a.date ?? a.appointment?.date;
          const apptTime = a.appointment_time ?? a.start_time ?? a.time ?? a.appointment?.time;
          const patientObj = a.patient ?? a.patient_data ?? a.patient_details ?? a.patientInfo ?? a.patient?.data;
          // console.log('patientObj:', patientObj);

          return {
            appointment_id: apptId,
            date: apptDate,
            time: apptTime,
            raw_time: apptTime,
            formatdate: this.formatDate(apptDate),
            status: a.status ?? a.state ?? '',
            appointment_type: a.appointment_type ?? a.appointment?.appointment_type ?? 'other',
            collect_later: Boolean(a.collect_later ?? false),
            medicine_collection: a.medicine_collection ?? a.medicineCollection ?? false,

            patient_id: patientObj?.id ?? a.patient_id ?? a.patientId ?? null,
            name: `${patientObj?.first_name ?? ''} ${patientObj?.last_name ?? patientObj?.name ?? ''}`.trim(),
            full_name: patientObj?.full_name ?? patientObj?.name ?? '',
            contact_number: patientObj?.contact_number ?? patientObj?.phone ?? '',
            card_id: patientObj?.card_id ?? '',
            age: patientObj?.age ?? 0,
            gender: patientObj?.gender ?? '',
            is_free: patientObj?.is_free ?? false,

            medicines: '',
            personal_dues: 0,
            visit_fees: 0,
            received_cash: 0,
            received_online: 0,
            card_dues: 0,
            notes: '',
            is_courier: this.normalizePatientMode(patientObj?.is_courier ?? false)
          };
        });

        this.allMedicineQueue.sort((a, b) => {
          const tA = new Date((a.date ?? '') + ' ' + (a.time ?? ''))?.getTime() || 0;
          const tB = new Date((b.date ?? '') + ' ' + (b.time ?? ''))?.getTime() || 0;
          return tB - tA;
        });
        this.recomputeMedicineQueueView();

        // Build appointment id list and filter out falsy ids
        const appointmentIds = this.allMedicineQueue.map(q => q.appointment_id).filter((id: any) => id != null);
        // console.log('appointmentIds:', appointmentIds);

        if (appointmentIds.length === 0) {
          this.recomputeMedicineQueueView();
          return;
        }

        // Fetch prescriptions by appointment IDs
        this.prescriptionsService.getPrescriptionsByAppointments(appointmentIds)
          .subscribe((presRes: any) => {
            if (!presRes.success || !Array.isArray(presRes.data)) return;

            const map = new Map(
              presRes.data.map((p: any) => [p.appointment_id ?? p.appointmentId ?? p.appointment?.id, p])
            );

            this.allMedicineQueue = this.allMedicineQueue.map(item => {
              const key = item.appointment_id;
              const p = map.get(key);
              return p
                // @ts-ignore
                ? { ...item, ...p, is_courier: this.normalizePatientMode(p.is_courier ?? item.is_courier) }
                : item;
            });

            // Final sort (safely handle missing date/time)
            this.allMedicineQueue.sort((a, b) => {
              const tA = new Date((a.date ?? '') + ' ' + (a.time ?? ''))?.getTime() || 0;
              const tB = new Date((b.date ?? '') + ' ' + (b.time ?? ''))?.getTime() || 0;
              return tB - tA;
            });
            this.recomputeMedicineQueueView();
          }, () => {
            this.recomputeMedicineQueueView();
          });
      });
  }

  private recomputeMedicineQueueView(): void {
    const list = Array.isArray(this.allMedicineQueue) ? this.allMedicineQueue : [];
    const counts = {
      all: list.length,
      normal: 0,
      scheduled: 0,
      OPD: 0,
      COURIER: 0,
      NRI: 0
    };

    for (const item of list) {
      const isScheduled = this.isScheduledLaterMedicineItem(item);
      if (isScheduled) counts.scheduled += 1;
      else counts.normal += 1;

      const mode = this.normalizePatientMode(item?.is_courier);
      if (mode === 'OPD') counts.OPD += 1;
      else if (mode === 'COURIER') counts.COURIER += 1;
      else counts.NRI += 1;
    }

    this.medicineQueueCounts = counts;
    this.visibleMedicineQueue = list.filter((item: any) => this.isMedicineQueueItemVisible(item));
    this.updateMedicineNextPatientIndex();
  }

  private updateMedicineNextPatientIndex(): void {
    this.medicineNextPatientIndex = -1;
    if (!Array.isArray(this.visibleMedicineQueue) || this.visibleMedicineQueue.length === 0) return;

    const visible = this.visibleMedicineQueue.map((item: any, index: number) => ({ item, index }));

    const normalVisible = visible.filter(({ item }) => !this.isScheduledLaterMedicineItem(item));
    const scheduledVisible = visible.filter(({ item }) => this.isScheduledLaterMedicineItem(item));

    let candidates = visible;
    if (this.medicineQueueTypeFilter === 'normal') {
      candidates = normalVisible;
    } else if (this.medicineQueueTypeFilter === 'scheduled') {
      candidates = scheduledVisible;
    } else if (normalVisible.length > 0) {
      candidates = normalVisible;
    }

    if (candidates.length === 0) return;

    const pendingCandidate = candidates.find(({ item }) => this.getMedicineQueuePaymentStatus(item) === 'pending');
    if (pendingCandidate) {
      this.medicineNextPatientIndex = pendingCandidate.index;
      return;
    }

    const paidCandidate = candidates.find(({ item }) => this.getMedicineQueuePaymentStatus(item) === 'paid');
    if (paidCandidate) {
      this.medicineNextPatientIndex = paidCandidate.index;
      return;
    }

    this.medicineNextPatientIndex = candidates[0].index;
  }

  isMedicineNextPatient(index: number): boolean {
    return index === this.medicineNextPatientIndex;
  }

  getMedicineNextLabel(item: any): string {
    return this.getMedicineQueuePaymentStatus(item) === 'pending' ? 'NEXT PAY' : 'NEXT MEDS';
  }

  getMedicineNextClass(item: any): string {
    return this.getMedicineQueuePaymentStatus(item) === 'pending' ? 'next-pay' : 'next-meds';
  }

  getModernStatusColorClass(item: any): string {
    const s = String(item.status || '').toLowerCase();

    // Exact mapping for every status
    if (s === 'scheduled' || s === 'pending') return 'border-blue';
    if (s === 'assistant_doctor') return 'border-purple';
    if (s === 'assistant_doctor_done') return 'border-teal';
    if (s === 'doctor') return 'border-green';
    if (s === 'medicine' || s === 'medicine_scheduled') return 'border-orange';
    if (s === 'reception' || s === 'receptionist') return 'border-cyan';
    if (s === 'completed') return 'border-gray';

    return 'border-gray';
  }

  getWaitTimeColorClass(label: string): string {
    if (!label) return 'text-muted';
    if (label.includes('In ') || label.includes('Just now')) return 'text-muted';

    const matchMins = label.match(/Waiting (\d+)m/);
    const matchHours = label.match(/Waiting (\d+)h/);

    if (matchHours) return 'text-danger fw-bolder'; // 1h+
    if (matchMins) {
      const mins = parseInt(matchMins[1], 10);
      if (mins < 15) return 'text-muted'; // neutral
      if (mins < 30) return 'text-warning fw-semibold'; // amber
      return 'text-danger fw-semibold'; // red
    }
    return 'text-muted';
  }

  getWaitTimeLabel(createdAt: string): string {
    if (!createdAt) return '';
    const now = new Date();

    // Check if it looks like a time-only string (fallback)
    if (createdAt.length <= 8 && createdAt.includes(':')) {
      const timeParts = createdAt.split(':');
      if (timeParts.length < 2) return '';
      const aptTime = new Date();
      aptTime.setHours(parseInt(timeParts[0], 10), parseInt(timeParts[1], 10), 0, 0);
      createdAt = aptTime.toISOString();
    }

    const aptTime = new Date(createdAt);
    if (isNaN(aptTime.getTime())) return '';

    const diffMs = now.getTime() - aptTime.getTime();
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 0) {
      return `In ${Math.abs(diffMins)}m`;
    }
    if (diffMins === 0) {
      return 'Just now';
    }
    if (diffMins < 60) {
      return `Waiting ${diffMins}m`;
    }
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    return `Waiting ${hours}h ${mins}m`;
  }

  getQueueLifecycleLabel(item: any): string {
    const s = String(item?.status || '').toLowerCase();
    if (s === 'scheduled' || s === 'pending') return 'Scheduled';
    if (s === 'assistant_doctor') return 'Asst. Dr. Consulting';
    if (s === 'assistant_doctor_done') return 'Assistant Doctor Done';
    if (s === 'doctor') return 'In Consultation';
    if (s === 'medicine' || s === 'medicine_scheduled') return 'Pharmacy';
    if (s === 'reception' || s === 'receptionist') return 'Reception';
    if (s === 'completed') return 'Completed';
    return 'Waiting';
  }
}
